import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-deposit',
  templateUrl: './new-deposit.component.html',
  styleUrls: ['./new-deposit.component.css']
})
export class NewDepositComponent implements OnInit {
  title="Deposit Details"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master-account/new-deposit/new-deposit.component.ts